<template>
  <div
    class="text-center flex items-center justify-center w-full"
    :style="{ height: height + 'px' }"
  >
    <feather-icon
      icon="LoaderIcon"
      class="bx-spin"
      :class="color"
      :svgClasses="size"
    ></feather-icon>
  </div>
</template>

<script>
export default {
  name: 'page-loader',
  props:{ 
    color:{
      type:String,
      default:'text-warning'
    },
    size:{
      type:String,
      default:'w-10 h-10'
    },
    height:{
      type:[Number, String],
      default:50
    }
  }
}
</script>